import React, { Component } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';

var Config = require('../../config');

class ModalDetails extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.state = {
		    show: false,
		    patients:"",
		    lab_sections:"",
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(id) {
		this.props.waiting.handleShow("Cargando...");
		fetch(Config.default.apiGateway.URL+'unit_reserved/by_unit_id?id='+id,{
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result){
					swal("Error", result, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({ 
					show:true,
					patients:response.patients,
					lab_sections:response.lab_sections
				});
				
			}
		})

	}


	render(){
		const { t } = this.props;
		return(
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles de Unidad</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row form-group">
		        		{this.state.patients.length > 0 ?
			        		<div>
				        		<div className="col-xs-12">
				        			<span>Unidad reservada para: </span>
				        		</div>
				        		
			        			{this.state.patients.map((p, i)=>(
			        				<div key={i} className="col-xs-12">
			        					<label>{p}</label>
			        				</div>
			        			))}
				        		
			        		</div>
		        		:null}
		        		{this.state.lab_sections.length > 0 ?
		        			<div>
		        				<div className="col-xs-12">
									<span>Secciones de laboratorio pendientes: </span>
								</div>
								
								{this.state.lab_sections.map((l, i)=>(
									<div key={i} className="col-xs-12">
										<label>{l}</label>
									</div>
								))}
								
		        			</div>
		        		:null}
				        		
					</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalDetails) 